import { render } from "./backgroundPresenter.vue?vue&type=template&id=09d743c9&scoped=true"
import script from "./backgroundPresenter.vue?vue&type=script&lang=js"
export * from "./backgroundPresenter.vue?vue&type=script&lang=js"

import "./backgroundPresenter.vue?vue&type=style&index=0&id=09d743c9&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d743c9"]])

export default __exports__